import React, { useState } from "react";
import { ShieldCheck, ShieldAlert, ShieldOff, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

const ALWAYS = ["admin", "super_admin"];

export const UserMfaCell = ({ u, currentUser, onChanged }) => {
  const [confirm, setConfirm] = useState(false);
  const canManage = !(u.role === "super_admin" && currentUser?.role !== "super_admin");
  const call = async (fn, msg) => {
    try { await fn(); toast.success(msg); onChanged(); } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
  };
  const state = u.mfa_enabled ? ["On", "text-emerald-700", ShieldCheck] : u.mfa_enforced ? ["Setup at next login", "text-amber-700", ShieldAlert] : ["Off", "text-slate-500", ShieldOff];
  const [label, cls, Icon] = state;
  return (
    <div className="flex items-center gap-2" data-testid={`user-mfa-${u.id}`}>
      <span className={`text-xs font-semibold flex items-center gap-1 ${cls}`} data-testid={`user-mfa-status-${u.id}`}><Icon className="h-3.5 w-3.5" />{label}</span>
      {canManage && !ALWAYS.includes(u.role) && (
        <label className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-muted-foreground" title="Require MFA for this user">
          <Switch checked={!!u.mfa_enforced} onCheckedChange={(v) => call(() => api.post(`/users/${u.id}/mfa/require`, { required: v }), v ? "MFA now required for this user" : "MFA now optional for this user")}
            data-testid={`user-mfa-require-${u.id}`} />Required
        </label>
      )}
      {ALWAYS.includes(u.role) && <span className="text-[10px] uppercase tracking-wider text-muted-foreground">Always required</span>}
      {canManage && u.mfa_enabled && u.id !== currentUser?.id && (
        <Button variant="ghost" size="sm" className="rounded-none h-7" title="Reset MFA" onClick={() => setConfirm(true)} data-testid={`user-mfa-reset-${u.id}`}><RotateCcw className="h-3 w-3" /></Button>
      )}
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent className="rounded-none">
          <AlertDialogHeader><AlertDialogTitle>Reset MFA for {u.name}?</AlertDialogTitle>
            <AlertDialogDescription>Their authenticator and backup codes stop working and they're signed out. {u.mfa_enforced ? "They'll set MFA up again at their next login." : "MFA will be off until they turn it on again."}</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel className="rounded-none">Cancel</AlertDialogCancel>
            <AlertDialogAction className="rounded-none" onClick={() => call(() => api.post(`/users/${u.id}/mfa/reset`), "MFA reset")} data-testid="user-mfa-reset-confirm">Reset MFA</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
